export const role_names = {
    ADMIN: 'RE_ADMIN',
    LOTTO_ADMIN: 'RE_LOTTO_ADMIN',
    RETAILER: 'RE_RETAILER',
};
